export default function PageLoading() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      minHeight: 200,
      padding: 40,
    }}>
      <div style={{
        width: 32,
        height: 32,
        border: '3px solid #f0f0f0',
        borderTopColor: '#FF6B00',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}
